export default "__VITE_ASSET__99252242__"